module.exports = __webpack_public_path__ + "mybuild/static/img/erweima.e84770f9.jpg";